import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-page-intrucao',
  templateUrl: './page-intrucao.component.html',
  styleUrls: ['./page-intrucao.component.scss']
})
export class PageIntrucaoComponent implements OnInit {

  @Output() customEvent = new EventEmitter<boolean>(true);

  @Input() tokenAcesso:string;

  constructor() { }

  ngOnInit(): void {
  }

  iniciarPoa():void{
    localStorage.setItem("@termoAceite", this.tokenAcesso);
    this.customEvent.emit(false);
  }

}
